import { ChangeDetectionStrategy, Component, ViewEncapsulation, forwardRef, input } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { RadioButtonConfig } from "./radioButton.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "primeng/api";
import { RadioButtonModule } from "primeng/radiobutton";
import { WRAPPER_TOKEN, V_SKIP_REGISTER, V_FORM_CONTROL_TOKEN } from "../wrapper.tokens";
import { GcLayoutModule } from "src/app/components/v-layout/layout.module";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:      'v-radio-button',
    templateUrl:   './radioButton.component.haml',
    styleUrls:     ['./radioButton.component.sass', '../input.style.sass'],
    encapsulation: ViewEncapsulation.None,
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VRadioButtonComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VRadioButtonComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VRadioButtonComponent), multi: true },
        { provide: V_SKIP_REGISTER, useValue: false }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, RadioButtonModule, ReactiveFormsModule, SharedModule, GcLayoutModule, TranslateModule]
})
export class VRadioButtonComponent<T = unknown> extends InputFormWrapper<RadioButtonConfig, string> {
    protected readonly _baseConfig: RadioButtonConfig = RadioButtonConfig.baseTheme.Default;
    public name = input<string>();
    public inputValue = input<T>(undefined, { alias: 'value' });
}